export const mappingConfigs = {
  default: {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  chsmeo_traffic_light_count: {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  tagil_traffic_light_count: {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  chsmeo_meteo_data_count: {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  "chsmeo_pdk_cams_count?format=from_service": {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  "chsmeo_cams_kps?format=count_from_service": {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  "chsmeo_cams?format=stat": {
    basic_widget: {
      items: {
        work: "work",
        error: "error",
        inactive: "inactive"
      },
      total: "count"
    }
  },
  chsmeo_tlt7_count: {
    basic_widget: {
      items: {
        T7: "tlt7"
      },
      total: "count"
    }
  },
  "chsmeo_wialon_tracks?format=stat": {
    basic_widget: {
      items: {
        GeoCenter: "GeoCenter",
        Evis: "Evis",
        stroimekhanizatsiya: "stroimekhanizatsiya",
        stroytech: "stroytech",
        ural_syberian_company: "ural_syberian_company",
        stroi_servis: "stroi_servis"
      },
      total: "count"
    }
  },
  "tagil-detectors": {
    basic_widget: {
      items: {
        work: "work",
        error: "error"
      },
      total: "count"
    }
  },
  "TagilPublicTransport?format=vehicles_stats": {
    basic_widget: {
      items: {
        Автобус: "Автобус ",
        Трамвай: "Трамвай"
      },
      total: "count"
    }
  },
  "TagilPublicTransport?format=stops_stats": {
    basic_widget: {
      items: {
        Автобусы: "Муниципальные автобусы",
        Трамвай: "Трамвай "
      },
      total: "count"
    }
  },
  "TagilPublicTransport?format=routes_stats": {
    basic_widget: {
      items: {
        Автобусы: "Муниципальные автобусы",
        Трамвай: "Трамвай "
      },
      total: "count"
    }
  },
  chsmeo_ngpt_count: {
    basic_widget: {
      items: {
        bus: "bus",
        mtaxi: "mtaxi",
        tram: "tram",
        trolleybus: "trolleybus"
      },
      total: "count"
    }
  },
  event_stat: {
    basic_widget: {
      items: {
        accident: "ДТП",
        road_works: "Ремонтные работы",
        events: "Мероприятия"
      },
      total: "count"
    }
  },
  chsmeo_traffic_light: {
    object_card: {
      main: {
        location: "name",
        phase: "phase",
        mode: "mode",
        status: "status"
      }
    }
  },
  "tagil_traffic_light?format=from_service": {
    object_card: {
      main: {
        location: "name",
        phase: "phase",
        mode: "mode",
        status: "status"
      }
    }
  },
  "chsmeo_meteo_data?format=from_service": {
    object_card: {
      main: {
        location: "name",
        status: "status"
      },
      meteoData: "data"
    }
  },
  chsmeo_tlt7: {
    object_card: {
      main: {
        location: "name",
        report: "report",
        voltage: "voltage"
      }
    }
  },
  chsmeo_ngpt: {
    object_card: {
      main: {
        type: "type"
      }
    }
  },
  "12ff4f13-bb98-43c8-bd34-d69808b72c5d": {
    object_card: {
      main: {
        type: "type"
      }
    }
  },
  "7fc1a76e-84e7-44b7-aed0-b3df8b04b867": {
    object_card: {
      main: {
        contractor: "contractor",
        contact: "contact",
        contract: "contract",
        location: "name",
        period: "period",
        object_id: "obj_id"
      }
    }
  },
  "f07ce2e2-253a-4ed7-9529-463b1b2ff1ad": {
    object_card: {
      main: {
        Электроснабжение: "Электроснабжение",
        Статус: "Статус",
        Опоры: "Опоры",
        Комплекс: "Комплекс",
        "Канал связи": "Канал связи"
      }
    }
  },
  chsmeo_wialon_tracks: {
    object_card: {
      main: {
        reg_number: "name",
        organization: "organization"
      }
    }
  },
  events: {
    object_card: {
      main: {
        event_class: "event_class_id",
        address: "address",
        closed_line_count: "closed_line_count",
        customer: "customer",
        performer: "performer",
        phone_number: "phone_number",
        start_time: "start_time",
        end_time: "end_time"
      }
    }
  },
  "http://192.168.88.69:10262/api/ritm": {
    object_card: {
      main: {
        afterDate: "afterDate",
        beforeDate: "beforeDate",
        description: "description",
        disposition: "disposition",
        place: "place",
        executor: "executor",
        fullName: "fullName",
        phone: "phone",
        contract: "contract",
        type: "type"
      }
    }
  },
  chsmeo_cams: {
    object_card: {
      main: {
        location: "title"
      },
      camerasList: "pdk_cams"
    }
  },
  chsmeo_cams_kps: {
    object_card: {
      main: {
        location: "name"
      },
      camerasList: "kps_cams"
    }
  },
  "8560fe75-49b2-432a-8494-eab530c8fc4e": {
    object_card: {
      main: {
        address: "адрес",
        name: "name"
      },
      macroCam: "camera_id"
    }
  },
  "db258075-aaf2-43c3-85da-065834afada3": {
    object_card: {
      main: {
        address: "адрес",
        name: "name"
      },
      macroCam: "camera_id"
    }
  },
  "track/telemetry.track_data?format=last_tracks": {
    object_card: {
      main: {
        name: "name",
        reg_number: "reg_number",
        description: "description",
        group_name: "group_name",
        uid: "uid",
        speed: "speed",
        course: "course",
        gps_time: "gps_time"
      }
    }
  },
  "count/2600d74b-3842-4311-9aa7-a2d742df36da?field=online": {
    basic_widget: {
      items: {
        work: "true",
        error: "false"
      },
      total: "count"
    }
  },
  "2600d74b-3842-4311-9aa7-a2d742df36da": {
    object_card: {
      main: {
        address: "name",
        status: "online",
        state: "state",
        alarm: "alarm"
      }
    }
  },
  "count/875c93e3-dc09-41bc-b675-51b7461abca1?field=error_flags": {
    basic_widget: {
      items: {
        work: "0",
        error: "Неизвестные"
      },
      total: "count"
    }
  },
  "875c93e3-dc09-41bc-b675-51b7461abca1": {
    object_card: {
      main: {
        address: "description",
        phase: "phase"
      }
    }
  },
  "fe19e836-9559-4834-9f3d-722001dd3dbf": {
    object_card: {
      main: {
        pdk_name: "pdk_name",
        time: "time",
        rs: "rs",
        surf: "surf"
      }
    }
  },
  "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3": {
    object_card: {
      main: {
        pdk_name: "pdk_name",
        time: "time",
        rs: "rs",
        surf: "surf"
      }
    }
  },
  "https://lenobl.ritm3.ru/xml_server_results/?limit=10": {
    object_card: {
      hard_cameras: {
        data: "data"
      }
    }
  },
  "TagilPublicTransport?format=vehicles": {
    object_card: {
      main: {
        Терминал: "terminal_id",
        "Гос.номер": "reg_number",
        "Тип ТС": "vehicle_type&name",
        "Модель ТС": "vehicle_model",
        Организация: "organization&name",
        "Телефон организации": "organization&phone",
        "Email организации": "organization&email"
      }
    }
  },
  "TagilDetector?format=stats": {
    basic_widget: {
      items: {
        work: "active",
        error: "not_active"
      },
      total: "count"
    }
  },
  "TagilPublicTransport?format=dit_stats": {
    basic_widget: {
      items: {
        work: "active",
        error: "not_active"
      },
      total: "total"
    }
  },
  TagilDetector: {
    object_card: {
      main: {
        id: "detector_id",
        status: "is_active",
        geometry: "geometry_clone",
        comment: "comment"
      }
    }
  },
  "TagilPublicTransport?format=stops": {
    object_card: {
      main: {
        name: "name"
      }
    }
  },
  "TagilPublicTransport?format=dit": {
    object_card: {
      main: {
        name: "name"
      }
    }
  },
  tagil_rt_routes_lines: {
    object_card: {
      main: {
        Маршрут: "title"
      }
    }
  }
};

export const dataMapping = (data, layer_id, type) => {
  const mappingConfig = mappingConfigs[layer_id]
    ? mappingConfigs[layer_id][type]
    : mappingConfigs.default[type];
  const newData = {};

  if (layer_id === "https://lenobl.ritm3.ru/xml_server_results/?limit=10") {
    newData.hard_cameras = data;
    return newData;
  }

  Object.keys(mappingConfig).forEach(e => {
    if (e !== "items" && e !== "main" && e !== "cameras") {
      newData[e] = data[mappingConfig[e]];
    } else {
      if (!newData[e]) newData[e] = [];

      Object.keys(mappingConfig[e]).forEach(n => {
        const chunks = mappingConfig[e][n].split("&");
        const chunksLength = chunks.length;
        let value = String(data[chunks[0]]);
        if (value) {
          if (chunksLength > 1) {
            value = JSON.parse(value);
          }
          for (let i = 1; i < chunksLength; i++) {
            value = value[chunks[i]];
          }
        }
        if (value !== undefined) {
          newData[e].push({ type: n, value: value || 0 });
        }
      });
    }
  });
  return newData;
};
